<app-power-bi-input tabindex="0" [reportInput]="powerBIConfig"></app-power-bi-input>
